import * as z from "zod";
import { gql } from "graphql-request";

import { FullscreenEntry } from "./fullscreenEntry";
import { SysFragment } from "../sys";
import { FullscreenEntryCarouselFragment } from "./fullscreenCarousel";
import { RelatedMediaFragment } from "../relatedMedia";

export const EsportFullscreenEntry = FullscreenEntry.extend({
  __typename: z.literal("EsportFullscreenEntry"),
});

export type EsportFullscreenEntry = z.infer<typeof EsportFullscreenEntry>;

export const EsportFullscreenEntryFragment = gql`
  fragment EsportFullscreenEntryFragment on EsportFullscreenEntry {
    __typename
    sys {
      ...SysFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    sortDate
    localized {
      ... on FullscreenEntryCarousel {
        ...FullscreenEntryCarouselFragment
      }
    }
  }

  ${SysFragment}
  ${FullscreenEntryCarouselFragment}
  ${RelatedMediaFragment}
`;
